

import taskServices from '../taskServices';
import moment from 'moment';
import { useAppData } from '../../../../../context/AppDataContext';
import TaskProgressGauge from './editor/TaskProgressGuage';
import { useState } from 'react';
import TaskDetailsView from './TaskDetailsView';
import AssigneeBadge from './editor/AssigneeBadge';
import TaskStatusBadge from './editor/TaskStatusBadge';
import PriorityBadge from './editor/PriorityBadge';
import TaskForm from './TaskForm';
import { Link } from 'react-router-dom';
import TaskScheduleBadge from './editor/TaskScheduleBadge';

function TaskListView({taskList, callBack}) {    
    
    const [taskDetails,setTaskDetails] = useState(null);
    const {projectDD, userDD, getDDDataById} = useAppData();
    const handleCallBack = () =>{
        setTaskDetails(false);
        callBack();
    }
    return (
        <div className='row'>
            <div className='col-md-12'>
                {taskList && 
                    <div className="table-responsive border rounded-3">
                        <table className='table mb-0 ' style={{fontSize:14}}>
                            <thead className='table-secondary'>
                                <tr>
                                    <td>Task Name</td>
                                    <td>Assigned To</td>
                                    <td>Schedule</td>
                                    <td>Priority</td>
                                    <td>Status</td>
                                    <td>Progress</td>
                                </tr>
                            </thead>
                            <tbody>
                                {taskList.map(task=>
                                    <tr role="button" className={taskServices.statusTableColorClass[task.taskStatus] || "bg-light text-dark"} key={task.id} onClick={()=>setTaskDetails(task)}>
                                        
                                        <td>
                                            <div className='fw-bold'>{taskServices.typeIcons[task.calendarType]} {task.title}</div>
                                            <div> 
                                                {
                                                    task.projectId ?
                                                        getDDDataById(projectDD,task.projectId)?.label
                                                        :
                                                        <i className='text-danger'>No Project Assigned</i>
                                                }
                                            </div>
                                        </td>
                                        {/* <td><AssigneeBadge value={task.assignedTo} /></td> */}
                                        <td>{getDDDataById(userDD, task.assignedTo)?.label || "Unassigned"}</td>
                                        <td>
                                            <TaskScheduleBadge 
                                                startDate={task.startDate}
                                                startTime={task.startTime}
                                                endDate={task.endDate}
                                                endTime={task.endTime}
                                            /> 
                                        </td>
                                        <td><PriorityBadge value={task.priority} /></td>
                                        <td><TaskStatusBadge value={task.taskStatus} /></td>
                                        <td><TaskProgressGauge value={task.progress} height={40} width={40} /></td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                }
                <TaskDetailsView taskDetails={taskDetails} setTaskDetails={setTaskDetails} callBack={handleCallBack} />
            </div>
        </div>
  )
}

export default TaskListView